module.exports = __webpack_public_path__ + "img/sonstige_ausbildung.e47423d.svg";